import React from 'react';
import { createRoot } from 'react-dom/client';
import '../../../index.css';
import SharedClipPage from './SharedClipPage';
import { AppContextProvider } from '@/context/AppContext/AppContext';
import UserInitializer from '@/components/atoms/UserInitializer';

const renderSharedClipPage = (rootId: string, props = { logger: {} }) => {
  const rootElement = document.getElementById(rootId);
  if (!rootElement) {
    return;
  }

  const root = createRoot(rootElement);

  root.render(
    // @ts-ignore
    <AppContextProvider {...props}>
      <UserInitializer>
        <SharedClipPage />
      </UserInitializer>
    </AppContextProvider>
  );

  return () => {
    root?.unmount();
  };
};

export default renderSharedClipPage;
